import { useQuery } from 'react-query'
import { ProblemDetails } from '../errors'
import { getHelp } from './services'

export const QUERYKEY_HELPTEXT = 'helptext'
export function useHelpText(key: string) {
    return useQuery<string, ProblemDetails>([QUERYKEY_HELPTEXT, key], () => getHelp(key), {
        retry: false,
    })
}
